
import api from "../../../../api/api"


const getActivityList = (projectId) =>{
    return new Promise((resolve, reject)=>{
        api.get("erp/project-activity/"+projectId).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg: res.data.msg
                })
            }
          }).catch( (error) => {
            reject({
                msg: "Something Went Wrog",
                error : error
            })
          })
    })
}

const projectActivityServices = {
    getActivityList,
}
export default projectActivityServices;